import TimeSelectInput from "../../TimeSelectInput";
import { changeForm } from "../../../searchFlightsSlice";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { TimeSelect } from "../../../../../types";
import { convertTimeSelect } from "../../../utils";
import { useTranslation } from "react-i18next";

function TimeInputSFO() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const departingTime = useAppSelector(
    (state) => state.searchFlights.form.departingTimeSelect
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);
  const onSelect = (time: TimeSelect) => {
    dispatch(
      changeForm({
        departingTime: convertTimeSelect(time),
        departingTimeSelect: time,
      })
    );
  };

  return (
    <div className="column sfo-date pl-0 is-one-quarter" id="time-sel">
      <TimeSelectInput
        id="departure-time-input"
        disabled={disabled}
        value={departingTime}
        label={t("SFO_TIME")}
        onSelect={onSelect}
        noTime={true}
      />
    </div>
    
  );
}

export default TimeInputSFO;
